<template>
  <div class="container">
    <div style="margin-top: 50px">
      <p style="margin: 10px 0;">
        <span
          style="display: inline-block;width: 100px;text-align: right;margin-right: 5px;font-size: 0.8rem;color: #999999"
        >新密码:</span>
        <cube-input placeholder="新密码" type="password"  v-model="updateUser.newPassword" style="width: 200px;display: inline-block"></cube-input>
      </p>
      <p style="margin: 10px 0;">
        <span
          style="display: inline-block;width: 100px;text-align: right;margin-right: 5px;font-size: 0.8rem;color: #999999"
        >确定新密码:</span>
        <cube-input placeholder="确定新密码" type="password"  v-model="updateUser.newPasswords" style="width: 200px;display: inline-block"></cube-input>
      </p>
      <div class="bt" style="margin-top: 20px" @click="add">确定修改</div>
    </div>
  </div>
</template>

<script>

import { updatePassWord } from "@/api/bapi";
export default {
  name: "Feedback",
  data() {
    return {
      selectedLabelDefault: "我的",
      tabs: [
        {
          label: "首页",
          icon: "cubeic-home"
        },
        {
          label: "我的",
          icon: "cubeic-person"
        }
      ],
      updateUser:{},
    };
  },
  created() {
    this.getInfo();
  },
  watch: {
    $route(to, from) {
      if (/\/Password/gi.test(to.path)) {
        this.getInfo();
      }
    }
  },
  methods: {
    getInfo() {
       if (localStorage.getItem("loginUserInfo")) {
        let userInfo = JSON.parse(localStorage.getItem("loginUserInfo"));

        this.updateUser.userId = userInfo.sysUser.userId;
        console.log(userInfo);
      } else {
        this.$Message.error("登陆失效，请重新登录");
        this.$router.push("/login");
      }
    },
    errorShow(msg) {
      this.$Message.error(msg);
      setTimeout(() => {
        this.addMd = false;
        this.$nextTick(() => {
          this.addMd = true;
        });
      }, 100);
    },
    add() {
      
      if (!this.updateUser.newPassword || this.updateUser.newPassword == "") {
        this.errorShow("请输入新密码");
      }
      else if (this.updateUser.newPassword !=this.updateUser.newPasswords) {
        this.errorShow("两次密码不一致");
      } else {
        updatePassWord(this.updateUser)
          .then(res => {
          if (res.status == 200) {
            if (res.data.code == 0) {
              this.$Message.success("修改成功");
              this.updateUser.newPassword='';
              this.updateUser.newPasswords='';
            } else {
              this.errorShow(res.data.msg);
            }
          }
          })
          .catch(function(reason) {});
      }
    },
    changeHandler(label) {
      if (label == "我的") {
        this.$router.push({ path: "Center" });
      } else {
        this.$router.push({ path: "Index" });
      }
    }
  }
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
.bg {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-color: #f5f5f5;
}
.top {
  height: 3rem;
  background-color: #45b035;
}
.logo {
  width: 30%;
  line-height: 3rem;
}
.logo img {
  width: 100%;
  margin-top: 10px;
}
.tab {
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 1px solid #f1ebeb;
  background-color: white;
}
.photo {
  width: 30%;
}
.photo img {
  width: 100%;
}
h3 {
  font-size: 1.4rem;
  font-weight: bold;
  margin-top: 5px;
}
.list {
  width: 100%;
  margin: 20px auto 0;
  text-align: left;
}
.list li {
  padding: 20px;
  background-color: white;
  border-bottom: 1px solid rgb(222, 221, 221);
}
.ic {
  float: right;
}
.bt {
  width: 40%;
  margin: 0px auto;
  height: 45px;
  line-height: 45px;
  border-radius: 6px;
  text-align: center;
  font-size: 0.8rem;
  color: white;
  background-color: #fc9153;
}
</style>



// WEBPACK FOOTER //
// src/components/Password.vue